// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Contacts_wrapper__3_5By","contact_info":"Contacts_contact_info__1OCiw"};